'use strict';

import React from 'react';

const PageNumber = ({ page, active, callback }) => {
  return React.createElement(
    'button',
    { className: `PageNumber onsched-secondary-background-color-hover ${page === active ? 'onsched-primary-color onsched-secondary-background-color active' : 'onsched-shadow-background-color onsched-dark-color'} ${page - active >= -2 && page - active <= 2 ? 'available' : ''}`, onClick: callback, type: 'button' },
    page
  );
}

export default PageNumber
